export const lineConfig = {
  CAL: {
    abbr: "CAL",
    color: "#009c4b",
    contrastText: "#ffffff",
    fullName: "Changi Airport Branch Line",
    order: 10,
  },
  CCL: {
    abbr: "CCL",
    color: "#f99c25",
    contrastText: "#000000",
    fullName: "Circle Line",
    order: 4,
  },
  CCLE: {
    abbr: "CCLE",
    color: "#f99c25",
    contrastText: "#000000",
    fullName: "Circle Line Extension",
    order: 11,
  },
  DTL: {
    abbr: "DTL",
    color: "#005bc0",
    contrastText: "#ffffff",
    fullName: "Downtown Line",
    order: 5,
  },
  EWL: {
    abbr: "EWL",
    color: "#009c4b",
    contrastText: "#ffffff",
    fullName: "East-West Line",
    order: 1,
  },
  NEL: {
    abbr: "NEL",
    color: "#8e3494",
    contrastText: "#ffffff",
    fullName: "North East Line",
    order: 3,
  },
  NSL: {
    abbr: "NSL",
    color: "#e02725",
    contrastText: "#ffffff",
    fullName: "North-South Line",
    order: 2,
  },
  TEL: {
    abbr: "TEL",
    color: "#bb5117",
    contrastText: "#ffffff",
    fullName: "Thomson-East Coast Line",
    order: 6,
  },
  BPLRT: {
    abbr: "BP",
    color: "#5c6367",
    contrastText: "#ffffff",
    fullName: "Bukit Panjang LRT",
    order: 7,
  },
  SKGLRT: {
    abbr: "SK",
    color: "#5c6367",
    contrastText: "#ffffff",
    fullName: "Sengkang LRT",
    order: 8,
  },
  PGLLRT: {
    abbr: "PG",
    color: "#5c6367",
    contrastText: "#ffffff",
    fullName: "Punggol LRT",
    order: 9,
  },
};

export const disabledLine = ["CAL", "CCLE"];
